import application from 'application/application';

import templateUrl from './legal-partner.template.html';

import controller from './legal-partner.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.legal-partner', {
			url: '/pecas',
			views: {
				'default@root.default': { templateUrl, controller }
			},
			data: {
				documentTitle: 'Peças'
			}
		});
	}
]);
